import cloneDeep from 'lodash/cloneDeep';

export default function mergePermission(allPermission, permissionDuRole) {
  const permissions = cloneDeep(allPermission);
  permissionDuRole.forEach((permission) => {
    permissions.forEach((module) => {
      module.categorie.forEach((categorie) => {
        categorie.droit.forEach((droit) => {
          if (permission === droit.link) {
            droit.selected = true;
            module.selected = true;
          }
        });
      });
    });
  });
  return permissions;
}
